import { checkResponse, hashCode, isEmail, myReplacer } from "src/components/js/statics1";
import personSettingsClass from "./personSettingsClass";
import personDontAsksClass from "./PersonDontAsksClass";
import { asiakas_fetchList } from "../asiakas/AsiakasFunctions";

export default class personClass {
  constructor(personId = null, token = null) {
    this.personId = personId;
    this.tyomaaPersonId = 0;
    this.tyomaaId = 0;
    this.personFirstName = "";
    this.personLastName = "";
    this.personPhone = "";
    this.personPhoneVerified = false;
    this.personEmail = "";
    this.personEmailVerified = false;
    this.personMemo = "";
    this.lastLoginTime = "";
    this.settings = new personSettingsClass(personId, token);
    this.dontAsks = new personDontAsksClass(personId);
    this.accessToken = token;
    this.darkMode = true;
    this.asiakasList = [];
    this.asiakasListIsFetched = false;
    this.ownerAsiakasId = null;
  }
  get token() {
    return this.accessToken;
  }
  get isHelperEditor() {
    return this.settings.isHelperEditor || this.settings.isSystemAdmin;
  }
  get isRoleManager() {
    return this.settings.isRoleManager || this.settings.isSystemAdmin;
  }
  get isDeveloper() {
    return this.settings.isDeveloper || this.settings.isSystemAdmin;
  }
  get isSystemAdmin() {
    const a = this.settings.isSystemAdmin;
    return a;
  }
  get defaultPersonPvmStatusId() {
    return this.settings.defaultPersonPvmStatusId;
  }
  set defaultPersonPvmStatusId(value) {
    this.settings.defaultPersonPvmStatusId = value;
  }
  get isAnyAdmin() {
    return this.settings.isAnyAdmin;
  }

  get isBetoniAdmin() {
    return this.settings.isBetoniAdmin;
  }
  get isPumppuAdmin() {
    return this.settings.isPumppuAdmin;
  }
  get isTuoteAdmin() {
    return this.settings.isTuoteAdmin;
  }
  get isHinnastoAdmin() {
    return this.settings.isHinnastoAdmin;
  }
  get isLattiaAdmin() {
    return this.settings.isLattiaAdmin;
  }
  get isKeikkaAdmin() {
    return this.settings.isKeikkaAdmin;
  }
  get oletusAdminYritysId() {
    return this.settings.oletusAdminYritysId;
  }
  get defaultCompanyId() {
    return this.settings.oletusAdminYritysId;
  }

  asiakasListContains = (asiakasId) => {
    if (this.asiakasList == null || this.asiakasList.length == 0) {
      return false;
    }
    for (let i = 0; i < this.asiakasList.length; i++) {
      if (this.asiakasList[i].asiakasId == asiakasId) {
        return true;
      }
    }
    return false;
  };

  savePersonLastLoginTime = async (token) => {
    if (this.personId == null || this.personId == 0) {
      return;
    }
    const addr = "/api/person/didLogIn/" + this.personId;
    const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!(await checkResponse(response).success)) return;
  };

  fetchPersonByToken = async (token) => {
    this.accessToken = token;
    const addr = "/api/person/getPersonByToken/" + token;
    const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    }).catch((error) => {
      console.log("fetchPersonByToken: " + error);
      return null;
    });
    // check response
    if (!response.ok) {
      console.log("fetchPersonByToken: failed to fetch person by token");
      console.log("fetchPersonByToken: " + response.status + " " + response.statusText);
      return null;
    }
    const personJson = await response.json();

    if (personJson.length > 0) {
      this.dontAsks.personId = personJson[0].personId;
      this.personId = personJson[0].personId;
      this.personFirstName = personJson[0].personFirstName;
      this.personLastName = personJson[0].personLastName;
      this.personPhone = personJson[0].personPhone;
      this.personEmail = personJson[0].personEmail;
      this.personMemo = personJson[0].personMemo;
      this.lastLoginTime = personJson[0].lastLoginTime;
      this.darkMode = personJson[0].darkMode;
      this.ownerAsiakasId = personJson[0].ownerAsiakasId;

      this.settings = new personSettingsClass(this.personId, token);
      await this.settings.init(token);
    }

    this.asiakasList = await asiakas_fetchList(
      this.personId,
      null,
      null,
      token,
      this.ownerAsiakasId
    );
    this.asiakasListIsFetched = true;

    if (personJson.length > 0) {
      return this;
    } else {
      return null;
    }
  };

  get personFullName() {
    return (this.personFirstName || "") + " " + (this.personLastName || "");
  }
  static personFullNameStatic(person) {
    if (!person) return "";
    return (person.personFirstName || "") + " " + (person.personLastName || "");
  }
  get isKesken() {
    return this.personFirstName == "";
  }
  clear() {
    this.personId = 0;
    this.tyomaaPersonId = 0;
    this.tyomaaId = 0;
    this.personFirstName = "";
    this.personLastName = "";
    this.personPhone = "";
    this.personEmail = "";
    this.personMemo = "";
    this.lastLoginTime = null;
    this.ownerAsiakasId = null;
  }
  setPerson(jsonData) {
    this.personId = jsonData.personId;
    this.tyomaaId = jsonData.tyomaaId;
    this.personFirstName = jsonData.personFirstName;
    this.personLastName = jsonData.personLastName;
    this.personPhone = jsonData.personPhone;
    this.personEmail = jsonData.personEmail;
    this.personMemo = jsonData.personMemo;
    this.lastLoginTime = jsonData.lastLoginTime;
    this.ownerAsiakasId = jsonData.ownerAsiakasId;
  }

  personError(allowEdit = true) {
    let r = { txt: null, error: false, errorTxt: null };
    const _isEmail = isEmail(this.personEmail);
    if (this.personPhone == null || this.personPhone.length < 2) {
      if (allowEdit) {
        r = { errorTxt: "Syötä puhelinnumero", error: true };
      } else {
        r = { errorTxt: "Puhelinnumero puuttuu", error: true };
      }
    } else if (!_isEmail) {
      if (allowEdit) {
        r = { errorTxt: "Syötä sähköpostiosoite", error: true };
      } else {
        r = { errorTxt: "Sähköpostiosoite puuttuu", error: true };
      }
    } else if (
      (this.personFirstName == null || this.personFirstName.length < 2) &&
      (this.personLastName == null || this.personLastName.length < 2)
    ) {
      if (allowEdit) {
        r = { errorTxt: "Syötä nimi", error: true };
      } else {
        r = { errorTxt: "Nimi puuttuu", error: true };
      }
    }
    let txt = "";
    if (this.personFirstName != null && this.personFirstName.length > 0) {
      txt += " " + this.personFirstName;
    }
    if (this.personLastName != null && this.personLastName.length > 0) {
      txt += " " + this.personLastName;
    }
    if (_isEmail && txt.length === 0) txt = this.personEmail;
    txt += " " + this.personPhone;
    r.txt = txt;
    return r;
  }
  savePersonToDB = async (token) => {
    if (this.personId === 0) return false;
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        personFirstName: this.personFirstName,
        personLastName: this.personLastName,
        personPhone: this.personPhone,
        personMemo: this.personMemo,
        lastLoginTime: this.lastLoginTime,
        personId: this.personId,
        personEmail: this.personEmail,
      }),
    };
    const result = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/person/set",
      requestOptions
    ).catch((error) => console.log(error));
    return result.ok;
  };

  get personHash() {
    const c =
      this.personId +
      this.personFirstName +
      this.personLastName +
      this.personPhone +
      this.personEmail;
    return hashCode(c);
  }

  // create json string without circular references
  json() {
    const replacerWrapper = (key, value) => myReplacer(key, value, "person");
    return JSON.stringify(this, replacerWrapper);
  }
}

export async function fetchPersonKeikkas(personId, token) {
  if (personId == 0 || personId == null) return [];
  try {
    const url1 = import.meta.env.VITE_SERVER_URL + "/api/person/getPersonKeikkas/" + personId;
    const response = await fetch(url1, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "fetchPersonKeikkas");
    if (!cResponse.success) return [];
    const result = cResponse.data;
    return result;
  } catch (err) {
    console.log(err);
  }
}

// filter by startDate, endDate
// filter by asiakasId if asiakasId is not null
export async function fetchPersonKeikkasDetailed(
  personId,
  token,
  startDate,
  endDate,
  asiakasId = null,
  tyomaaId = null
) {
  startDate.setHours(0, 0, 0, 0); // set to 00:00:00
  endDate.setHours(23, 59, 59, 999); // set to 23:59:59

  if (personId === 0) return;
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
        "Cache-Control": 10,
      },
      body: JSON.stringify({
        personId: personId,
        startDate: startDate,
        endDate: endDate,
        asiakasId: asiakasId,
        tyomaaId: tyomaaId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/person/getPersonKeikkasDetailed/",
      requestOptions
    );
    const cResponse = await checkResponse(response, "fetchPersonKeikkasDetailed");
    if (!cResponse.success) {
      console.log("fetchPersonKeikkasDetailed: failed to fetch person keikkas");
      return [];
    }
    const result = cResponse.data;
    return result;
  } catch (err) {
    console.log(err);
  }
}

export async function fetchPersonKeikkasByEmail(email, token) {
  try {
    const url1 = import.meta.env.VITE_SERVER_URL + "/api/person/getPersonKeikkasByEmail/" + email;
    const response = await fetch(url1, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "fetchPersonKeikkasByEmail");
    if (!cResponse.success) return false;
    const result = cResponse.data;
    return result;
  } catch (err) {
    console.log(err);
  }
}
